<!-- After "Konto erstellen". The account exists but is not usable yet — it stays
     `not_validated` until the mailed link is opened — so this says what is
     outstanding rather than welcoming the guest in. -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <div class="onb__topbar onb__topbar--split">
      <span></span>
      <div class="onb-progress onb-progress--dark" data-id="progress"></div>
    </div>
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Fast geschafft' ) %></p>
    <!-- One key, wholly emphasised — same reason as the register step's title. -->
    <h1 class="onb__head-title"><em><%= _lcs( 'E-Mail bestätigen' ) %></em></h1>
    <p class="onb__head-sub"><%= _lcs( 'Wir haben dir eine Nachricht geschickt.' ) %></p>
  </header>

  <div class="onb__scroll onb__done">
    <span class="onb-done__icon"><i class="icon icon--mail"></i></span>

    <p class="onb-done__lead">
      <%= _lcs( 'Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.', { email: email } ) %>
    </p>

    <p class="onb-note">
      <i class="icon icon--info"></i>
      <span><%= _lcs( 'Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.' ) %></span>
    </p>

    <p class="auth__switch">
      <a class="auth__link auth__link--strong" href="#" data-id="resend"><%= _lcs( 'Link erneut senden' ) %></a>
    </p>
  </div>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="to-login"><%= _lcs( 'Zur Anmeldung' ) %></button>
    <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="guest"><%= _lcs( 'Erstmal ohne Konto ansehen' ) %></button>
  </footer>

</main>
